/*
  «Бегущие цифры» для денежных значений: при смене цены число линейно
  пересчитывается от старого значения к новому, сохраняя формат витрины
  (валюта, разделители, копейки). Публикуется как window.sbAnimateMoney,
  чтобы секции подключали файл тегом script без сборки.
*/

(() => {
  if (window.sbAnimateMoney) return;

  /** Длительность пересчёта: столько же бежит цена на референсе. */
  const COUNT_DURATION_MS = 500;
  /** Число внутри отформатированной цены: цифры с разделителями разрядов и дробью. */
  const MONEY_NUMBER_RE = /\d[\d.,\s ]*/;

  /**
   * Разбирает отформатированную цену на число и шаблон вокруг него,
   * чтобы промежуточные значения печатались в том же виде.
   * @param {string} text например "$202.50", "202,50 €" или "$1,440.00"
   */
  function parseMoney(text) {
    const match = text.match(MONEY_NUMBER_RE);
    if (!match) return null;

    const raw = match[0].trim();
    const decimalMatch = raw.match(/[.,](\d{1,2})$/);
    const decimals = decimalMatch ? decimalMatch[1].length : 0;
    const integerPart = decimalMatch ? raw.slice(0, raw.length - decimals - 1) : raw;
    const thousandsMatch = integerPart.match(/[.,\s ]/);
    const value = Number(integerPart.replace(/\D/g, '') + (decimalMatch ? `.${decimalMatch[1]}` : ''));
    if (Number.isNaN(value)) return null;

    return {
      value,
      decimals,
      decimalSep: decimalMatch ? raw[raw.length - decimals - 1] : '',
      thousandsSep: thousandsMatch ? thousandsMatch[0] : '',
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + match[0].length),
    };
  }

  /** Печатает значение по шаблону из parseMoney. */
  function formatMoney(value, spec) {
    const [integerRaw, fraction] = value.toFixed(spec.decimals).split('.');
    const integer = spec.thousandsSep
      ? integerRaw.replace(/\B(?=(\d{3})+(?!\d))/g, spec.thousandsSep)
      : integerRaw;
    const number = fraction ? integer + spec.decimalSep + fraction : integer;
    return spec.prefix + number + spec.suffix;
  }

  /**
   * Прокручивает содержимое элемента от текущей цены к целевой.
   * Живой регион на время бега выключается, иначе скринридер зачитывает
   * каждый кадр вместо одного финального значения.
   *
   * @param {HTMLElement} element узел с отформатированной ценой
   * @param {string} targetText новая цена в том же формате
   */
  window.sbAnimateMoney = function sbAnimateMoney(element, targetText) {
    if (element.dataset.moneyFrame) {
      cancelAnimationFrame(Number(element.dataset.moneyFrame));
      delete element.dataset.moneyFrame;
    }

    const from = parseMoney(element.textContent);
    const to = parseMoney(targetText);
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!from || !to || calm || from.value === to.value) {
      element.textContent = targetText;
      return;
    }

    const liveBefore = element.getAttribute('aria-live');
    element.setAttribute('aria-live', 'off');
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / COUNT_DURATION_MS, 1);
      if (progress >= 1) {
        delete element.dataset.moneyFrame;
        if (liveBefore === null) {
          element.removeAttribute('aria-live');
        } else {
          element.setAttribute('aria-live', liveBefore);
        }
        // Финал - исходная строка, без следов промежуточного форматирования
        element.textContent = targetText;
        return;
      }
      element.textContent = formatMoney(from.value + (to.value - from.value) * progress, to);
      element.dataset.moneyFrame = String(requestAnimationFrame(tick));
    };

    element.dataset.moneyFrame = String(requestAnimationFrame(tick));
  };
})();
